<div class="main-container">
	<div class="container">
		<ng-content select=".filters"></ng-content>

		<div class="right">
			<button
				mat-button
				class="user-dropdown"
				[ngClass]="{'has-company':company?.logoUrl}"
				[matMenuTriggerFor]="userMenu"
			>
				<span class="company-logo" *ngIf="company?.logoUrl">
					<img [src]="company.logoUrl" />
				</span>
				<avatar></avatar>
			</button>
		</div>
	</div>
</div>

<mat-menu #userMenu="matMenu">
	<button mat-menu-item matTooltip="Unit Settings" (click)="unitSettings()">
		<mat-icon>square_foot</mat-icon>
		Unit Conversion
	</button>

	<button mat-menu-item [matMenuTriggerFor]="helpMenu" class="help">
		<mat-icon>help_outline</mat-icon>
		Help
	</button>

	<button mat-menu-item (click)="openArticles()">
		<mat-icon>article</mat-icon>
		Knowledge Article
	</button>
	
	<button *ngIf="isSiteSelected" mat-menu-item (click)="openCostingDialog()">
		<mat-icon>attach_money</mat-icon>
		Costing Details
	</button>

	<button mat-menu-item (click)="logout()">
		<mat-icon>logout</mat-icon>
		Logout
	</button>
</mat-menu>

<mat-menu #helpMenu="matMenu">
	<a mat-menu-item href="javascript:$zopim.livechat.window.show();">
		<mat-icon>chat</mat-icon>
		Contact Support
	</a>
	<a mat-menu-item href="https://help.strayos.com/" target="_blank">
		<mat-icon>info</mat-icon>
		Help Center
	</a>
</mat-menu>
